import { Model } from '@/models/Model';
export class Participant extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Participant';
        this.$endpoint = '/chat/participants';
        this.$fillable = [];
    }
    setDeleteEndpoint(user, roomId) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/chat/participants/${roomId}/${user}`;
        return this;
    }
    resolvePrimaryKey() {
        return '';
    }
}
